define('components/course/collections/modules',[
    'components/course/collections/base',
    'components/course/models/module'
], function (BaseCollection, Module) {
    "use strict";

    return BaseCollection.extend({
        "model": Module
    });
});

